import { render, staticRenderFns } from "./locations-table.vue?vue&type=template&id=eab5cc76"
import script from "./locations-table.vue?vue&type=script&lang=js"
export * from "./locations-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports